;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { MenuItemSub } from '../types/menu';

export const EU_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
] as const;

/** Paths that belong to the business wallet section (root, currency routes, cards). */
export function isBusinessWalletPathActive(pathname: string): boolean {
  if (pathname === '/') return true;
  if (/^\/[a-z]{3}$/.test(pathname)) return true;
  if (pathname.startsWith('/wallet/') || pathname.startsWith('/card/')) return true;
  return false;
}

export function isOrganisationEURegistered(
  orgCountryId: number | undefined,
  countries: readonly { id: number; iso_code: string }[] | undefined
): boolean {
  if (!orgCountryId || !countries) return false;
  const orgCountry = countries.find((country) => country.id === orgCountryId);
  return orgCountry
    ? (EU_COUNTRY_CODES as readonly string[]).includes(orgCountry.iso_code.toUpperCase())
    : false;
}

export function hasAnyEURegisteredEntity(
  entities: readonly { country_id: number }[] | undefined,
  countries: readonly { id: number; iso_code: string }[] | undefined
): boolean {
  if (!entities?.length || !countries) return false;

  return entities.some((entity) => {
    if (!entity.country_id) return false;
    const entityCountry = countries.find((country) => country.id === entity.country_id);
    if (!entityCountry?.iso_code) return false;
    return (EU_COUNTRY_CODES as readonly string[]).includes(entityCountry.iso_code.toUpperCase());
  });
}

export function computeHasActiveEntityWallet(params: {
  entities: readonly { country_id: number }[] | undefined;
  countries: readonly { id: number; iso_code: string }[] | undefined;
  entityWallets: readonly { is_active?: boolean }[] | undefined;
}): boolean {
  const hasEURegisteredEntity = hasAnyEURegisteredEntity(params.entities, params.countries);
  const hasActiveEntityWallets =
    Array.isArray(params.entityWallets) &&
    params.entityWallets.some((wallet) => wallet.is_active === true);

  return hasEURegisteredEntity && hasActiveEntityWallets;
}

function isSalaryRewardsPathActive(pathname: string): boolean {
  return pathname.startsWith('/salary-rewards');
}

interface BuildWalletNavSubitemsParams {
  isEmployer: boolean;
  isEmployee: boolean;
  isContractor: boolean;
  isGigWorker: boolean;
  isIndividualCraft?: boolean;
  hasActiveEntityWallet: boolean;
  hasSalaryWalletAccess?: boolean;
}

export function buildWalletNavSubitems(
  params: BuildWalletNavSubitemsParams
): MenuItemSub[] | undefined {
  const {
    isEmployer,
    isEmployee,
    isContractor,
    isGigWorker,
    isIndividualCraft = false,
    hasActiveEntityWallet,
    hasSalaryWalletAccess = false,
  } = params;

  if (!isEmployer && !isEmployee && !isContractor && !isGigWorker && !isIndividualCraft)
    return undefined;

  // Client-side (employer) users see "Business wallet"; B2B2C workers see "Personal wallet".
  const primaryWalletTitle = isEmployer ? 'Business wallet' : 'Personal wallet';

  const subitems: MenuItemSub[] = [
    {
      title: primaryWalletTitle,
      url: '/',
      isPathActive: isBusinessWalletPathActive,
    },
  ];

  if (hasSalaryWalletAccess) {
    subitems.push({
      title: 'Salary rewards',
      url: '/salary-rewards',
      isPathActive: isSalaryRewardsPathActive,
    });
  }

  if (hasActiveEntityWallet) {
    subitems.push({
      title: 'Entity wallet',
      url: '/entity-wallet',
    });
  }

  if (isEmployer) {
    subitems.push({
      title: 'Deposits',
      url: '/deposits',
    });
  }

  if (!isEmployer) {
    subitems.push({
      title: 'Recipients',
      url: '/payment-recipients',
    });
  }

  return subitems;
}
